/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAccessDto
 */
export interface GetAccessDto {
    /**
     * 
     * @type {string}
     * @memberof GetAccessDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetAccessDto
     */
    uid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAccessDto
     */
    device?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAccessDto
     */
    accessDeviceDecode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAccessDto
     */
    userName?: string | null;
}

/**
 * Check if a given object implements the GetAccessDto interface.
 */
export function instanceOfGetAccessDto(value: object): value is GetAccessDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetAccessDtoFromJSON(json: any): GetAccessDto {
    return GetAccessDtoFromJSONTyped(json, false);
}

export function GetAccessDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccessDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'uid': json['uid'] == null ? undefined : json['uid'],
        'device': json['device'] == null ? undefined : json['device'],
        'accessDeviceDecode': json['accessDeviceDecode'] == null ? undefined : json['accessDeviceDecode'],
        'userName': json['userName'] == null ? undefined : json['userName'],
    };
}

export function GetAccessDtoToJSON(value?: GetAccessDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'uid': value['uid'],
        'device': value['device'],
        'accessDeviceDecode': value['accessDeviceDecode'],
        'userName': value['userName'],
    };
}

